/*
  Brandkit, 16 okt 2026: sluitingspagina (templates/page.aa-sluiting.json, wens Cris "We stoppen eind 2026").
  1. Aftelklok tot [data-aa-sl-end] (31-12-2026 23:59 Europe/Amsterdam). Daarna: koopblok weg, "De winkel is gesloten".
  2. Uitverkoopbundel: kies 3, 5 of 10 flacons en per flacon een geur (10 ml, op voorraad, uit all-perfume, label
     "CODE · naam" via window.aaGeurLabel). Toevoegen = 1 regel van het uitverkoopproduct met de eigenschappen
     "Geur 1" … "Geur N". Geen gewone flaconregels, dus de gewone bundels, deals en het cadeau worden niet geraakt.
  3. Vaste knop onderaan ("Kies je 3 geuren · €24,95"), stijl van /pages/ontdek (aa-ontdek.css).
  Eigen bestand; cart.js, cart-drawer.js, global.js en af0165e zijn niet gewijzigd.
*/
(function () {
  if (window.aaSluitingBound) return;
  window.aaSluitingBound = true;

  const money = (cents) => '€' + (cents / 100).toFixed(2).replace('.', ',');
  const geurLabel = (t) => (window.aaGeurLabel ? window.aaGeurLabel(t) : String(t));

  /* ---------- 1. Aftelklok en gesloten-stand ---------- */
  function initKlok() {
    const els = document.querySelectorAll('[data-aa-sl-end]');
    if (!els.length) return;
    const end = Date.parse(els[0].getAttribute('data-aa-sl-end'));
    const tick = () => {
      const left = end - Date.now();
      if (left <= 0) {
        document.querySelectorAll('[data-aa-sl-open]').forEach((e) => (e.hidden = true));
        document.querySelectorAll('[data-aa-sl-dicht]').forEach((e) => (e.hidden = false));
        document.querySelectorAll('[data-aa-sl-klok]').forEach((e) => (e.hidden = true));
        return false;
      }
      const d = Math.floor(left / 86400000);
      const h = Math.floor((left % 86400000) / 3600000);
      const m = Math.floor((left % 3600000) / 60000);
      document.querySelectorAll('[data-aa-sl-d]').forEach((e) => (e.textContent = d));
      document.querySelectorAll('[data-aa-sl-h]').forEach((e) => (e.textContent = h));
      document.querySelectorAll('[data-aa-sl-m]').forEach((e) => (e.textContent = m));
      document.querySelectorAll('[data-aa-sl-klok-tekst]').forEach((e) => (e.textContent = `Nog ${d} ${d === 1 ? 'dag' : 'dagen'}, ${h} uur en ${m} ${m === 1 ? 'minuut' : 'minuten'}`));
      return true;
    };
    if (tick()) {
      const timer = setInterval(() => { if (!tick()) clearInterval(timer); }, 30000);
    }
  }

  /* ---------- 2. Bundel ---------- */
  let geuren = null;
  function laadGeuren() {
    if (geuren) return geuren;
    geuren = fetch('/collections/all-perfume/products.json?limit=250', { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then((data) => {
        const lijst = [];
        (data.products || []).forEach((p) => {
          const tienMl = (p.variants || []).some((v) => v.available && /10\s*ML/i.test(String(v.title || v.option1 || '')));
          if (!tienMl) return;
          const label = geurLabel(p.title);
          if (lijst.indexOf(label) === -1) lijst.push(label);
        });
        return lijst.sort((a, b) => a.localeCompare(b, 'nl', { numeric: true }));
      })
      .catch(() => []);
    return geuren;
  }

  function initBundel(root) {
    const tiles = [...root.querySelectorAll('[data-aa-sl-tile]')];
    const lijstEl = root.querySelector('[data-aa-sl-geuren]');
    const knop = root.querySelector('[data-aa-sl-add]');
    const knopTekst = root.querySelector('[data-aa-sl-add-tekst]');
    const status = root.querySelector('[data-aa-sl-status]');
    if (!tiles.length || !lijstEl || !knop) return;
    let gekozen = {};

    const actief = () => tiles.find((t) => t.getAttribute('aria-checked') === 'true') || tiles[0];

    const bouwKeuzes = async () => {
      const tile = actief();
      const n = parseInt(tile.dataset.n, 10);
      const opties = await laadGeuren();
      root.querySelectorAll('[data-aa-sl-aantal]').forEach((e) => (e.textContent = opties.length));
      lijstEl.innerHTML = '';
      for (let i = 1; i <= n; i++) {
        const wrap = document.createElement('div');
        wrap.className = 'aa-sl__keuze';
        const id = `AaSlGeur-${i}`;
        const lab = document.createElement('label');
        lab.className = 'aa-sl__keuze-label';
        lab.setAttribute('for', id);
        lab.textContent = `Flacon ${i}`;
        const sel = document.createElement('select');
        sel.className = 'aa-sl__select';
        sel.id = id;
        sel.required = true;
        sel.dataset.i = String(i);
        const leeg = document.createElement('option');
        leeg.value = '';
        leeg.textContent = opties.length ? 'Kies je geur' : 'Geuren laden niet; probeer het opnieuw';
        sel.appendChild(leeg);
        opties.forEach((t) => {
          const o = document.createElement('option');
          o.value = t;
          o.textContent = t;
          sel.appendChild(o);
        });
        if (gekozen[i] && opties.indexOf(gekozen[i]) !== -1) sel.value = gekozen[i];
        wrap.appendChild(lab);
        wrap.appendChild(sel);
        lijstEl.appendChild(wrap);
      }
      sync();
    };

    const sync = () => {
      const tile = actief();
      const sels = [...lijstEl.querySelectorAll('select')];
      const klaar = sels.length > 0 && sels.every((s) => s.value);
      const open = sels.filter((s) => !s.value).length;
      knop.disabled = !klaar;
      knopTekst.textContent = klaar
        ? `In winkelwagen · ${tile.dataset.prijs}`
        : `Kies nog ${open} ${open === 1 ? 'geur' : 'geuren'}`;
      document.dispatchEvent(new CustomEvent('aa-sl:change', { detail: { n: tile.dataset.n, prijs: tile.dataset.prijs, open } }));
    };

    tiles.forEach((tile) => {
      tile.addEventListener('click', () => {
        tiles.forEach((t) => t.setAttribute('aria-checked', t === tile ? 'true' : 'false'));
        bouwKeuzes();
      });
      tile.addEventListener('keydown', (e) => {
        const i = tiles.indexOf(tile);
        const next = e.key === 'ArrowRight' || e.key === 'ArrowDown' ? tiles[(i + 1) % tiles.length] : e.key === 'ArrowLeft' || e.key === 'ArrowUp' ? tiles[(i - 1 + tiles.length) % tiles.length] : null;
        if (next) { e.preventDefault(); next.focus(); next.click(); }
      });
    });

    lijstEl.addEventListener('change', (e) => {
      if (e.target.matches('select')) { gekozen[e.target.dataset.i] = e.target.value; sync(); }
    });

    knop.addEventListener('click', async () => {
      if (knop.disabled) return;
      const tile = actief();
      const props = {};
      [...lijstEl.querySelectorAll('select')].forEach((s) => (props[`Geur ${s.dataset.i}`] = s.value));
      const drawer = document.querySelector('cart-drawer');
      const sections = drawer && typeof drawer.getSectionsToRender === 'function' ? drawer.getSectionsToRender().map((s) => s.id) : [];
      knop.disabled = true;
      knop.setAttribute('aria-busy', 'true');
      if (status) status.textContent = '';
      try {
        const res = await fetch(`${(window.routes && window.routes.cart_add_url) || '/cart/add'}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(tile.dataset.variant), quantity: 1, properties: props }], sections, sections_url: window.location.pathname }),
        });
        const state = await res.json();
        if (!res.ok || state.status) throw new Error(state.description || 'add failed');
        if (drawer && typeof drawer.renderContents === 'function' && state.sections) {
          drawer.classList.remove('is-empty');
          drawer.renderContents(state);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          return;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'aa-sluiting', cartData: state });
        if (status) status.textContent = 'Toegevoegd aan je winkelwagen.';
      } catch (err) {
        if (status) status.textContent = 'Toevoegen is niet gelukt. Probeer het opnieuw.';
      } finally {
        knop.removeAttribute('aria-busy');
        sync();
      }
    });

    bouwKeuzes();
  }

  /* ---------- 3. Vaste knop ---------- */
  function initBar(bar) {
    const target = document.querySelector(bar.dataset.target || '#aa-sluiting-koopblok');
    const main = bar.querySelector('[data-bar-main]');
    const button = bar.querySelector('button');
    if (!target || !main || !button) return;
    const label = bar.dataset.label || 'Kies je [n] geuren · [prijs]';
    document.addEventListener('aa-sl:change', (e) => {
      main.textContent = label.replace('[n]', e.detail.n).replace('[prijs]', e.detail.prijs);
    });
    let inView = false;
    let gesloten = false;
    const update = () => bar.classList.toggle('is-visible', !inView && !gesloten);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver((entries) => { entries.forEach((en) => (inView = en.isIntersecting)); update(); }, { threshold: 0.05 }).observe(target);
    } else {
      bar.classList.add('is-visible');
    }
    const dicht = document.querySelector('[data-aa-sl-dicht]');
    if (dicht && 'MutationObserver' in window) {
      new MutationObserver(() => { gesloten = !dicht.hidden; update(); }).observe(dicht, { attributes: true, attributeFilter: ['hidden'] });
      gesloten = !dicht.hidden;
    }
    button.addEventListener('click', () => {
      const leeg = [...target.querySelectorAll('select')].find((s) => !s.value);
      const goal = leeg || target.querySelector('[data-aa-sl-add]') || target;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      goal.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      if (goal.focus) setTimeout(() => goal.focus({ preventScroll: true }), reduce ? 0 : 450);
    });
    update();
  }

  const start = () => {
    initKlok();
    document.querySelectorAll('[data-aa-sl-bundel]').forEach(initBundel);
    document.querySelectorAll('[data-aa-sl-bar]').forEach(initBar);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
